/**
 * Android APK download — loaded from API (admin-uploaded releases on server disk).
 */
import axios from "axios";
import { apiBaseUrl } from "./api";

const LEGACY_APK_PATH = process.env.REACT_APP_ANDROID_APK_URL || "/downloads/coinmbx.apk";

export function getLegacyApkHref() {
  if (/^https?:\/\//i.test(LEGACY_APK_PATH)) return LEGACY_APK_PATH;
  return LEGACY_APK_PATH.startsWith("/") ? LEGACY_APK_PATH : `/${LEGACY_APK_PATH}`;
}

/** Fetch latest published release from backend (Mongo + disk). */
export async function fetchLatestAppRelease() {
  const base = apiBaseUrl();
  const { data } = await axios.get(`${base}/api/app-releases/latest`, {
    withCredentials: false,
  });
  return data;
}

export function resolveDownloadUrl(release) {
  if (!release) return null;
  if (release.download_url) return release.download_url;
  const base = apiBaseUrl();
  const path = release.download_path || "/api/app-releases/latest/download";
  return `${base}${path}`;
}

const XSS_NEEDLES = /onclick\s*=|onerror\s*=|onload\s*=|onmouseover\s*=|<script|javascript:|<marquee|<plaintext|confirm\s*\(|prompt\s*\(|<isindex|formaction\s*=/i;

/** Plain-text release notes only — never show XSS / HTML payloads. */
export function safeReleaseNotes(raw) {
  if (!raw || typeof raw !== "string") return "";
  const stripped = raw
    .replace(/<[^>]*>/g, "")
    .replace(/&lt;|&gt;|&quot;|&#39;|&amp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!stripped) return "";
  if (XSS_NEEDLES.test(raw) || XSS_NEEDLES.test(stripped)) return "";
  return stripped.slice(0, 500);
}

export function getDownloadPagePath() {
  return "/download";
}

/** Shown on /download — sideload steps for the Android APK. */
export const ANDROID_INSTALL_STEPS = [
  {
    n: 1,
    title: "Download the APK",
    body: "Tap Download above on your phone, or scan the QR code. Wait until the file finishes downloading.",
  },
  {
    n: 2,
    title: "Allow this browser to install apps",
    body: "When prompted, allow Chrome (or your browser) to install unknown apps. On Android 8+, you may need Settings → Apps → Special access → Install unknown apps.",
  },
  {
    n: 3,
    title: "Open the APK",
    body: "Open your Downloads folder and tap coinMBX.apk (or the filename shown). Confirm Install if Android warns about unknown sources.",
  },
  {
    n: 4,
    title: "Sign in and trade",
    body: "Open Coin MBX, sign in or register, complete verification, then use Spot and Wallet as usual.",
  },
];
